$(document).ready(function () {
 
   $(document).on('click', '.product_variant-switch', function () {
        var $switch = $(this);
        var index = $switch.index();  
        var $card = $switch.closest('.product-card-wrapper');

        var showImage = $card.data('showImage');
        if (typeof showImage === 'function') {
            showImage(index);  
        }
    });
 
  
    function initializeCarousels() {
        $('.card-wrapper.product-card-wrapper').each(function () {
            var $card = $(this);
            var $cardMedia = $card.find('.card__inner');
            var $mediaContainer = $cardMedia.find('.media');

            if (!$mediaContainer.length) return;

            var $images = $mediaContainer.find(
                'img.variant-media, img.product-grid-image'
            );
 
            if ($images.length <= 1) return;
 
            if ($card.data('carousel-init')) return;
            $card.data('carousel-init', true);
 
            $card.data('currentIndex', 0);

            $images.removeClass('active').eq(0).addClass('active');

            $card
                .find('.product_variant-switch')
                .removeClass('active')
                .eq(0)
                .addClass('active');
 
            addCarouselControls($cardMedia, $images);
        });
    }

    function addCarouselControls(cardMedia, images) {
        var $card = cardMedia.closest('.product-card-wrapper');

        var prevBtn = $('<button class="carousel-btn carousel-prev" aria-label="Previous">‹</button>');
        var nextBtn = $('<button class="carousel-btn carousel-next" aria-label="Next">›</button>');

        function updateButtons(index) {
            prevBtn.prop('disabled', index <= 0);
            nextBtn.prop('disabled', index >= images.length - 1);
        }

        function syncVariants(index) {
            $card
                .find('.product_variant-switch')
                .removeClass('active')
                .eq(index)
                .addClass('active');
        }

        function showImage(index) {
            index = Math.max(0, Math.min(index, images.length - 1)); // 🛡 safety

            images.removeClass('active').eq(index).addClass('active');
            $card.data('currentIndex', index);

            updateButtons(index);
            syncVariants(index);
        }
 
        $card.data('showImage', showImage);

        prevBtn.on('click', function (e) {
            e.preventDefault();
            showImage(($card.data('currentIndex') || 0) - 1);
        });

        nextBtn.on('click', function (e) {
            e.preventDefault();
            showImage(($card.data('currentIndex') || 0) + 1);
        });

        var wrapper = $('<div class="carousel-controls-wrapper"></div>');
        wrapper.append(prevBtn, nextBtn);

        cardMedia.css('position', 'relative');
        cardMedia.append(wrapper);
 
        showImage($card.data('currentIndex') || 0);
    }
    $(document).on('ajaxComplete', function() {
        initializeCarousels();
    });
    $(document).on('click','.header__icons .globe_icon',function(){
        if( $('.header__icons .localization-selector')){ 
        $('.header__icons .localization-selector').trigger('click');
        }
    });
    $(document).on('click','.menu-drawer__utility-links .globe_icon',function(){
        if( $('.menu-drawer__utility-links .localization-selector')){ 
        $('.menu-drawer__utility-links .localization-selector.HeaderLanguageMobile').trigger('click');
        }
    });
    $(document).on('click', '.product-card-wrapper .product_variants .product_variant', function () {
        var current_variant = $(this).data('variant-id');

        $(this)
            .closest('.product-card-wrapper')
            .find('a')
            .each(function () {
                var href = $(this).attr('href');

                if (!href) return;
 
                var newHref = href.replace(/([?&])variant=\d+/g, '');
 
                newHref += (newHref.indexOf('?') !== -1 ? '&' : '?') + 'variant=' + current_variant;

                $(this).attr('href', newHref);
            });
    });

     $(document).ready(function () {
        setTimeout(function () {
            initializeCarousels();
        }, 2000);
    });
});
 

document.addEventListener('DOMContentLoaded', function () {
    const checkbox = document.querySelector('#agreement-timestamp');
    const checkoutBtn = document.querySelector('#checkout');
    if(checkbox){

        checkbox.addEventListener('change', function () {
            if (this.checked) {
            checkoutBtn.removeAttribute('disabled');
            } else {
            checkoutBtn.setAttribute('disabled', 'disabled');
            }
        });
    }
}); 
 